import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import MainView from './Views';
import { Categories } from './Category'
import withArticleMetaData from './withArticleMetaData';

import ReactGA from 'react-ga';

class HomePage extends Component {
	componentDidMount() {
		ReactGA.initialize('UA-141772527-1');
		ReactGA.pageview('/');
	}
	render() {
		const { posts } = this.props;

		return (
			<div >
				<Header image='/images/wallpaper/alps_cliff.jpg' >
					<div className='row'>
						<div className='group'>
							<img src='/images/logo/cyberbutler-logo.png' className='logo-lg' />
						</div>
					</div>
				</Header>
				<Categories />
				<MainView posts={posts} />
			</div>
		);
	}
}

const Home = withArticleMetaData(HomePage);

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js